//import { color } from "html2canvas/dist/types/css/types/color";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/scrollbar.css";
import { useTranslation } from 'react-i18next';

const styles = {
  container: {
    height: "90vh",
    overflowY: "auto",
    backgroundColor: "black",
    padding: "16px",
  },
  wrapper: {
    maxWidth: "1000px",
    margin: "0 auto",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "24px",
    color: "#DFBD69",
  },
  card: {
    display: "flex",
    gap: "1%",
    padding: "16px",
    //backgroundColor: "#DFBD69",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    alignItems: "center",
    color: "black",
    marginBottom: "1%",
  },
  image: {
    width: "96px",
    height: "96px",
    objectFit: "cover",
    borderRadius: "8px",
    backgroundColor: "#e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    color: "#6b7280",
  },
  noimage: {
    width: "96px",
    height: "96px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    color: "transparent",
  },
  details: {
    flex: 1,
    color: "#DFBD69",
  },
};

// Dummy data for styling purposes
const dummyHistory = [
  {
    PID: 1,
    QTY: -50,
    STATUS: 0,
    REC_DATE: "2024-10-01T10:30:00"
  },
  {
    PID: 2,
    QTY: -75,
    STATUS: 1,
    REC_DATE: "2024-09-28T14:15:00"
  },
  {
    PID: 3,
    QTY: -100,
    STATUS: 0,
    REC_DATE: "2024-09-25T09:20:00"
  }
];

const dummyProducts = [
  {
    ID: 1,
    FILENAME: "Magic Sword",
    CATEGORY_DESC: "Weapons",
    REMARK: "A powerful magical sword with fire enchantment"
  },
  {
    ID: 2,
    FILENAME: "Crystal Shield",
    CATEGORY_DESC: "Armor",
    REMARK: "Protective shield made from enchanted crystal"
  },
  {
    ID: 3,
    FILENAME: "Healing Potion",
    CATEGORY_DESC: "Consumables",
    REMARK: "Restores health instantly when consumed"
  }
];

const getProductImageUrl = (product) => {
  // If your API returns an ImageUrl field, use it directly
  if (product?.ImageUrl) {
    return product.ImageUrl;
  }
  // Fallback to your previous logic if ImageUrl is not present
  if (product?.ID && product?.FILENAME) {
    return `${
      process.env.PUBLIC_URL
    }/static/media/product/${product.ID.toString().padStart(5, "0")}/${
      product.FILENAME
    }.png`;
  }
  return null;
};

// const GROUP_TYPE_LABELS = {
//   0: "Free",
//   1: "Daily",
//   2: "Weekly",
//   3: "Monthly",
//   4: "Yearly",
// };

const PurchaseHistory = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userID = localStorage.getItem("userID");
  const [history, setHistory] = useState([]);
  const [productList, setProductList] = useState([]);
  const [groupedHistory, setGroupedHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [useDummyData, setUseDummyData] = useState(false);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/booking/GetPurchaseHistory?ID=${userID}`
        );
        const data = await res.json();
        // Fix: Ensure we get an array from the API response
        const historyArray = Array.isArray(data) ? data : (data?.Table || []);
        setHistory(historyArray);
        // console.log("[PurchaseHistory] GetPurchaseHistory (booking)", {
        //   status: res.status,
        //   count: historyArray.length,
        //   historyArray,
        // });
      } catch (err) {
        console.error("Failed to fetch purchase history", err);
        // Use dummy data on error
        setUseDummyData(true);
        setHistory(dummyHistory);
        setProductList(dummyProducts);
      }
    };

    const fetchProducts = async () => {
      try {
        const res = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/member/getProduct"
        );
        const data = await res.json();
        const productsArray = Array.isArray(data) ? data : [];
        setProductList(productsArray);
        // console.log("Product", productsArray);
      } catch (err) {
        console.error("Failed to fetch product list", err);
        // Use dummy data on error
        setUseDummyData(true);
        setHistory(dummyHistory);
        setProductList(dummyProducts);
      }
    };

    // For styling purposes, use dummy data immediately
    // if (process.env.NODE_ENV === 'development') {
    //   setHistory(dummyHistory);
    //   setProductList(dummyProducts);
    //   setLoading(false);
    //   setUseDummyData(true);
    //   return;
    // }

    // Run both in parallel and wait both finish before setting loading false
    Promise.all([fetchHistory(), fetchProducts()]).then(() =>
      setLoading(false)
    );
  }, [userID]);

  const getSortedItems = () => {
    // Flatten all items and keep group info
    const allItems = groupedHistory.flatMap(group =>
      group.Data.map(item => ({
        ...item,
        groupName: group.GroupName
      }))
    );
    // Sort by RecDate (convert to Date for accuracy)
    return allItems.sort((a, b) => new Date(b.RecDate) - new Date(a.RecDate));
  };

  const getItemDetails = (item) => {
    const product = productList.find((p) => p.ID === item.PID);
    return product
      ? {
          ...product,
          quantity: 1,
          transactionDate: item.REC_DATE,
          coins: item.QTY, // keep the sign as-is
          purchaseMethod:
            item.STATUS === 0 ? "Purchased by Coin" : "Purchased by Card",
        }
      : null;
  };

  // useEffect(() => {
  //   const fetchGroupedHistory = async () => {
  //     try {
  //       const res = await fetch(
  //         `https://xianhefairy.com/LotusFairy_API/api/Product/GetHistoryPurchase?CustId=${userID}`
  //       );
  //       const data = await res.json();
  //       setGroupedHistory(Array.isArray(data) ? data : []);
  //     } catch (err) {
  //       console.error("Failed to fetch grouped purchase history", err);
  //       setGroupedHistory([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchGroupedHistory();
  // }, [userID]);

  useEffect(() => {
    const fetchGroupedHistory = async () => {
      const url = `https://xianhefairy.com/LotusFairy_API/api/Product/GetPurchaseHistorySort?CustID=${userID}`;
      // console.log("[PurchaseHistory] GET", url, {
      //   userID,
      //   typeofUserID: typeof userID,
      // });
      try {
        const res = await fetch(url);
        // Read as text first so a non-JSON/error body stays visible instead of
        // being swallowed by res.json() throwing.
        const text = await res.text();
        // console.log("[PurchaseHistory] GetPurchaseHistorySort response", {
        //   status: res.status,
        //   ok: res.ok,
        //   url: res.url,
        //   body: text,
        // });

        let data;
        try {
          data = JSON.parse(text);
        } catch {
          console.warn("[PurchaseHistory] response body was not JSON");
          data = null;
        }

        // console.log("[PurchaseHistory] parsed", {
        //   isArray: Array.isArray(data),
        //   length: Array.isArray(data) ? data.length : undefined,
        //   data,
        // });
        if (Array.isArray(data) && data.length > 0) {
          // console.log("[PurchaseHistory] first row", data[0]);
        }
        if (!Array.isArray(data)) {
          console.warn(
            "[PurchaseHistory] API did not return an array - the list renders empty",
            data,
          );
        }

        setGroupedHistory(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to fetch grouped purchase history", err);
        setGroupedHistory([]);
      } finally {
        setLoading(false);
      }
    };
    fetchGroupedHistory();
  }, [userID]);

  if (loading) {
    return <div style={styles.container}>{t('purchaseHistory.loading')}</div>;
  }

  // Ensure history is always an array before calling slice()
  const historyArray = Array.isArray(history) ? history : [];

  return (
    <div className="terms-modal-content" style={{ ...styles.container, color: "#F3CC5C" }}>
      <div style={styles.wrapper}>
        <button
          onClick={() => navigate("/account")}
          style={{ background: "none", border: "none", color: "#DFBD69", cursor: "pointer", fontSize: "1rem", display: "flex", alignItems: "center", gap: 6, marginBottom: 16, padding: 0 }}
        >
          &#8592; {t('purchaseHistory.back') || "Back"}
        </button>
        <h2 style={styles.heading}>{t('purchaseHistory.title')}</h2>
        {(Array.isArray(groupedHistory) && groupedHistory.length > 0) ? (
          groupedHistory.map((item, i) => (
            <div key={item.Uid || i} style={{ marginBottom: "32px" }}>
              <div style={styles.card}>
                {item.ProdThumbnail || item.ProdGif ? (
                  <img
                    src={item.ProdThumbnail || item.ProdGif}
                    alt={item.DocNo}
                    style={styles.image}
                  />
                ) : (
                  <div style={styles.noimage}></div>
                )}
                <div style={styles.details}>
                  <p>
                    <strong>{item.ProdDesc}</strong>
                  </p>
                  <p>
                    {t('purchaseHistory.qty')}: {item.Qty}
                    {item.ProdDesc && item.ProdDesc.toLowerCase().includes("gem") ? ` ${t('purchaseHistory.gems')}` : ""}
                  </p>
                  <p>
                    {t('purchaseHistory.amount')}: {(item.PayModeDesc === "Card" )
                      ? `US$ ${item.Amount}`
                      : item.Amount}
                  </p>
                  {item.TotalAmount !== undefined && item.TotalAmount !== null && item.TotalAmount !== "" && (
                    <p>
                      {t('purchaseHistory.totalAmount')}: {(item.PayModeDesc === "Card" && !(item.ProdDesc && item.ProdDesc.toLowerCase().includes("gem")))
                        ? `US$ ${item.TotalAmount}`
                        : `${item.TotalAmount} ${t('purchaseHistory.gems')}`}
                    </p>
                  )}
                  {item.GroupType !== 0 && <p>{t('purchaseHistory.payMode')}: {item.PayModeDesc}</p>}
                  <p>{t('purchaseHistory.purchasedOn')}: {item.RecDate}</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p style={{ color: "#F3CC5C" }}>{t('purchaseHistory.noPurchases')}</p>
        )}
      </div>
    </div>
  );

  // return (
  //   <div className="terms-modal-content" style={{ ...styles.container, color: "#F3CC5C" }}>
  //     <div style={styles.wrapper}>
  //       <h2 style={styles.heading}>Purchase History</h2>
  //       {groupedHistory.length === 0 ? (
  //         <p style={{ color: "#F3CC5C" }}>No purchases yet.</p>
  //       ) : (
  //         groupedHistory.map((group, idx) =>
  //           group.Data.map((item, i) => (
  //             <div key={item.Uid || i} style={{ marginBottom: "32px" }}>
  //               <div style={styles.card}>
  //                 {item.ProdThumbnail || item.ProdGif ? (
  //                   <img
  //                     src={item.ProdThumbnail || item.ProdGif}
  //                     alt={item.DocNo}
  //                     style={styles.image}
  //                   />
  //                 ) : (
  //                   <div style={styles.noimage}></div>
  //                 )}
  //                 <div style={styles.details}>
  //                   <p>
  //                     <strong>{item.ProdDesc}</strong>
  //                   </p>
  //                   <p>Item: {group.GroupName}</p>
  //                   <p>Qty: {item.Qty}</p>
  //                   <p>
  //                     Amount: {item.PayModeDesc === "Card" ? `$${item.Amount}` : item.Amount}
  //                   </p>
  //                   {item.TotalAmount !== undefined && item.TotalAmount !== null && item.TotalAmount !== "" && (
  //                     <p>
  //                       Total Amount: {item.PayModeDesc === "Card" ? `$${item.TotalAmount}` : item.TotalAmount}
  //                     </p>
  //                   )}
  //                   {group.GroupName !== "Free" && <p>Pay Mode: {item.PayModeDesc}</p>}
  //                   <p>Purchased on: {item.RecDate}</p>
  //                 </div>
  //               </div>
  //             </div>
  //           ))
  //         )
  //       )}
  //       {groupedHistory.length === 0 ? (
  //         <p style={{ color: "#F3CC5C" }}>No purchases yet.</p>
  //       ) : (
  //         getSortedItems().map((item, i) => (
  //           <div key={item.Uid || i} style={{ marginBottom: "32px" }}>
  //             <div style={styles.card}>
  //               {item.ProdThumbnail || item.ProdGif ? (
  //                 <img
  //                   src={item.ProdThumbnail || item.ProdGif}
  //                   alt={item.DocNo}
  //                   style={styles.image}
  //                 />
  //               ) : (
  //                 // <></>
  //                 <div style={styles.noimage}></div>
  //               )}
  //               <div style={styles.details}>
  //                 <p>
  //                   <strong>{item.ProdDesc}</strong>
  //                 </p>
  //                 <p>Item: {item.groupName}</p>
  //                 <p>Qty: {item.Qty}</p>
  //                 <p>
  //                   Amount: {item.PayModeDesc === "Card" ? `$${item.Amount}` : item.Amount}
  //                 </p>
  //                 {item.TotalAmount !== undefined && item.TotalAmount !== null && item.TotalAmount !== "" && (
  //                   <p>
  //                     Total Amount: {item.PayModeDesc === "Card" ? `$${item.TotalAmount}` : item.TotalAmount}
  //                   </p>
  //                 )}
  //                 {item.groupName !== "Free" && <p>Pay Mode: {item.PayModeDesc}</p>}
  //                 <p>Purchased on: {item.RecDate}</p>
  //               </div>
  //             </div>
  //           </div>
  //         ))
  //       )}
  //     </div>
  //   </div>
  // );
  // return (
  //   <div style={{ ...styles.container, color: "#F3CC5C" }}>
  //     <div style={styles.wrapper}>
  //       <h2 style={styles.heading}>Purchase History</h2>
  //       {groupedHistory.length === 0 ? (
  //         <p style={{ color: "#F3CC5C" }}>No purchases yet.</p>
  //       ) : (
  //         groupedHistory.map((group, idx) =>
  //           group.Data.length === 0 ? (
  //             <div key={idx} style={{ marginBottom: "32px" }}>
  //               <p>No items in this group.</p>
  //             </div>
  //           ) : (
  //             group.Data.map((item, i) => (
  //               <div key={item.Uid || i} style={{ marginBottom: "32px" }}>
  //                 <div style={styles.card}>
  //                   {item.ProdThumbnail || item.ProdGif ? (
  //                     <img
  //                       src={item.ProdThumbnail || item.ProdGif}
  //                       alt={item.DocNo}
  //                       style={styles.image}
  //                     />
  //                   ) : (
  //                     <div style={styles.image}>No Image</div>
  //                   )}
  //                   <div style={styles.details}>
  //                     <p>
  //                       <strong>{item.ProdDesc}</strong>
  //                     </p>
  //                     {/* <p>
  //                       <strong>{item.DocNo}</strong>
  //                     </p> */}
  //                     <p>Amulet Type: {group.GroupName}</p>
  //                     {/* <p>Product ID: {item.Pid}</p> */}
  //                     <p>Qty: {item.Qty}</p>
  //                     <p>Amount: {item.Amount}</p>
  //                     {/* Only show Pay Mode if not Free */}
  //                     {group.GroupName !== "Free" && <p>Pay Mode: {item.PayModeDesc}</p>}
  //                     <p>Purchased on: {item.RecDate}</p>
  //                   </div>
  //                 </div>
  //               </div>
  //             ))
  //           )
  //         )
  //       )}
  //     </div>
  //   </div>
  // );
};

export default PurchaseHistory;